export default "__VITE_ASSET__BAYE9Pii__"